import React from "react";

import {
  Content,
  Divider,
  Level,
  LevelItem,
  List,
  ListItem,
  Stack,
  StackItem
} from "@patternfly/react-core";

import BranchQualifications from "./BranchQualifications";
import QualificationBadges from "./QualificationBadges";
import GroupProgress from "./GroupProgress";

const BranchPanel = ({
  branch,
  isAuthUser,
  themeVersion
}) => {
  const activeQualifications = Object.values(
    branch.active_qualifications_for_branch ?? {}
  );

  const inactiveQualifications = Object.values(
    branch.inactive_qualifications_for_branch ?? {}
  );

  const groups = Object.values(
    branch.organization_branch_groups ?? {}
  );

  const hasQualifications = activeQualifications.length > 0;
  const showGroupProgress =
    isAuthUser && groups.length > 0;

  return (
    <Stack hasGutter>
      <StackItem>
        <Level>
          <LevelItem>
            <Content component="h3">
              {branch.organization_branch_name}
            </Content>

            {branch.organization_branch_number !== 0 && (
              <Content component="p">
                <strong>Numer zawodu:{" "}</strong>
                  {branch.organization_branch_number}
              </Content>
            )}
          </LevelItem>
        </Level>
      </StackItem>

      <StackItem>
        <BranchQualifications
          qualifications={activeQualifications}
        />
      </StackItem>

      {hasQualifications && (
        <>
          <StackItem>
            <Divider />
          </StackItem>

          <StackItem>
            <List isPlain>
              <ListItem>
                <strong>Arkusze egzaminacyjne:</strong>
              </ListItem>

              <ListItem>
                <QualificationBadges
                  activeQualifications={activeQualifications}
                  inactiveQualifications={inactiveQualifications}
                />
              </ListItem>

              {showGroupProgress && (
                <>
                  <ListItem>
                    Przygotowanie do praktycznego egzaminu zawodowego:
                  </ListItem>

                  <ListItem>
                    <GroupProgress
                      groups={groups}
                      themeVersion={themeVersion}
                    />
                  </ListItem>
                </>
              )}
            </List>
          </StackItem>
        </>
      )}
    </Stack>
  );
};

export default BranchPanel;